<template>
    <div class="select-org-container">
        <h2 v-if="!isUsedForProfileAccessLink" class="mb-2">Select An Organization</h2>
        <h2 v-else class="mb-2" style="text-align: center">To which Organization would you like to transfer?</h2>
        <div class="pa-4" style="min-width: 400px; max-height: 80%; overflow: scroll">
            <div v-for="(organization, index) in availableOrganizations" >
                <div class="link pb-3 pt-3 mt-2 mb-2 pl-3 text-center" @click="selectOrganization(organization.id)" >
                    {{organization.name}}
                    <div >
                        <app-chip v-if="organization.isEnterpriseAdminOrg" small label :color="'blue'" >Enterprise</app-chip>
                    </div>
                </div>
                
                <v-divider v-if="index !== availableOrganizations.length - 1"></v-divider>
            </div>
        </div>
        <app-btn color="primary" @click="logout" class="mt-2">Logout</app-btn>
        
    </div>
</template>

<script>

let viewport = document.querySelector("meta[name=viewport]");
viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');

import {getUserFromBrowserStorage, logout, switchSelectedOrganization} from '@/services/userService'

function stripOrgIdFromUrl(url) {
    if (!url) return url;
    const [path, queryString] = url.split('?');
    if (!queryString) return url;
    const params = new URLSearchParams(queryString);
    params.delete('orgId');
    const remaining = params.toString();
    return remaining ? `${path}?${remaining}` : path;
}

export default {
    name: "SelectOrganization",
    data() {
        return {
            availableOrganizations: null,
            isUsedForProfileAccessLink: false
        }
    },
    mounted() {
        let account = getUserFromBrowserStorage();
        const {availableOrganizations} = account;
        
        if (availableOrganizations.length == 1)
        {
            this.selectOrganization(availableOrganizations[0].id);
        }

        availableOrganizations.sort(function(a, b){
            if(a.name < b.name) { return -1; }
            if(a.name > b.name) { return 1; }
            return 0;
        })
        
        this.availableOrganizations = availableOrganizations

        let {isUsedForProfileAccessLink} = this.$route.query;
        this.isUsedForProfileAccessLink = isUsedForProfileAccessLink;
    },
    methods: {
        logout() {
            logout(() => this.$router.push('/login'));
            // this.$router.push('/login')
        },
        async selectOrganization(organizationId) {

            let selectedOrganization = this.availableOrganizations.find(x => x.id == organizationId);
            if (this.isUsedForProfileAccessLink && selectedOrganization.isEnterpriseAdminOrg) {
                alert("You cannot transfer to an Enterprise Organization. Please select a different Organization.");
                return;
            }

            this.$route.query.orgId = organizationId;
            const {account} = await switchSelectedOrganization(organizationId);

            this.$emit('setAccount', account);

            //if used for profileAccessLink then redirect back
            if (this.isUsedForProfileAccessLink) {
                await this.$router.push('/redeem-profile-access-link?orgSelected=true&shouldContinue=true&profileAccessLink=' + this.$route.query.profileAccessLink)
            } else {
                // Strip any stale orgId from the redirect URL — the httpService interceptor
                // would otherwise switch back to that org on the next API call.
                let redirectTarget = this.$route.query.redirect || '/';
                redirectTarget = stripOrgIdFromUrl(redirectTarget);
                await this.$router.push(redirectTarget)
                //location.reload()
            }
        }
    }
}
</script>

<style scoped>
.select-org-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100vh;
    background-color: #F9FAFB;
    font-family: 'Inter', sans-serif;
}

h2 {
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    color: #1F2937;
}

.link {
    border: 2px solid #E5E7EB;
    border-radius: 12px;
    background-color: white;
    transition: all 0.2s ease;
    font-weight: 500;
    color: #1F2937;
}

.link:hover {
    cursor: pointer;
    border-color: #33D3FF;
    background-color: rgba(51, 211, 255, 0.08);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(51, 211, 255, 0.15);
}


</style>